import {
  FileDown,
  ScrollText,
  IndianRupee,
  BadgeCheck,
  Check,
} from "lucide-react";
import { formatDate } from "../../utils/utils";
import {
  FaLinkedin,
  FaInstagram,
  FaFacebook,
  FaWhatsapp,
} from "react-icons/fa";
const payouts = [
  {
    invoice: "INV-2025-001",
    mode: "UPI",
    amount: "₹10,000",
    date: "03/05/2025",
  },
  {
    invoice: "INV-2025-002",
    mode: "Bank Transfer",
    amount: "₹10,000",
    date: "06/04/2025",
  },
  {
    invoice: "INV-2025-003",
    mode: "Bank Transfer",
    amount: "₹10,000",
    date: "05/03/2025",
  },
  {
    invoice: "INV-2025-004",
    mode: "UPI",
    amount: "₹10,000",
    date: "07/02/2025",
  },
  {
    invoice: "INV-2025-005",
    mode: "Bank Transfer",
    amount: "₹10,000",
    date: "04/01/2025",
  },
];
export default function AffiliateInformation({
  profile,
  formatCurrency,
  paidCommissionForDisplay,
  openDocumentModal,
}) {
  return (
    <> 
      <div className="grid grid-cols-1 lg:grid-cols-11 gap-6 mb-6">
        {/* Commission Summary */}
        <div className="col-span-full lg:col-span-4 bg-[#131313] border border-[#333333] p-3 md:p-6 rounded-lg">
          <h3 className="text-base md:text-lg font-bold mb-3 md:mb-4 flex items-center">
            <IndianRupee className="text-[#FFCA20] mr-2 w-4 h-4 md:w-5 md:h-5" /> Commission Summary 
          </h3>

          {/* First Row: Total Earnings - centered */}
          <div className="flex justify-center border border-[#333333] rounded-t-lg">
            <div className="text-center p-3 md:p-6 space-y-1 md:space-y-2 w-full sm:w-1/2 border-b border-[#333333]">
              <p className="text-[#F3F3F3] text-xs">TOTAL EARNINGS</p>
              <p className="text-lg md:text-xl font-bold">
                {profile.performance?.totalCommission || 0}
              </p>
            </div>
          </div>

          {/* Second Row: Paid & Pending */}
          <div className="grid grid-cols-2 border border-t-0 border-[#333333] rounded-b-lg">
            <div className="text-center p-3 md:p-6 space-y-1 md:space-y-2 border-r border-[#333333]">
              <p className="text-[#F3F3F3] text-xs">PAID COMMISSION</p>
              <p className="text-lg md:text-xl font-bold">
                {formatCurrency(paidCommissionForDisplay)}
              </p>
            </div>
            <div className="text-center p-3 md:p-6 space-y-1 md:space-y-2">
              <p className="text-[#F3F3F3] text-xs">PENDING PAYMENT</p>
              <p className="text-lg md:text-xl font-bold">
                {profile.performance?.pendingCommission || 0}
              </p>
            </div>
          </div>
        </div>

        {/* Compliance Status */}
        <div className="col-span-full lg:col-span-7 bg-[#131313] border border-[#333333] p-4 sm:p-6 rounded-lg">
          <h3 className="text-lg font-bold mb-4 flex items-center">
            <BadgeCheck className="text-[#FFCA20] mr-2" /> Compliance Status 
          </h3>
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
            {profile.documents &&
              Array.isArray(profile.documents) &&
              profile.documents.length > 0 ? (
              profile.documents.map((doc, index) => {
                // Handle different document structures
                const documentType = doc.type || doc.documentType || "Document";
                const documentStatus = doc.status || "pending";
                const documentFileName = doc.fileName || "Document";
                const documentFilePath = doc.filePath || "";
                const documentUploadedAt = doc.uploadedAt || "";
                
                // Format document type for display
                const displayType = documentType.replace(/_/g, " ");
              
                
                return (
                  <div
                    key={doc._id || index}
                    className="border border-[#333333] rounded-lg p-4"
                  >
                    <div className="flex flex-col sm:flex-row justify-between mb-1">
                      <p className="capitalize">{displayType}</p>
                      <div
                        className={`${
                          documentStatus.toLowerCase() === "verified"
                            ? "bg-green-500"
                            : documentStatus.toLowerCase() === "rejected"
                            ? "bg-red-500"
                            : "bg-[#FFCA20]"
                        } bg-opacity-20 ${
                          documentStatus.toLowerCase() === "verified"
                            ? "text-green-500"
                            : documentStatus.toLowerCase() === "rejected"
                            ? "text-red-500"
                            : "text-[#FFCA20]"
                        } px-3 py-1 rounded-full flex items-center mt-2 sm:mt-0`}
                      >
                        <Check className="w-4 h-4 mr-1" />{" "}
                        {documentStatus.charAt(0).toUpperCase() + documentStatus.slice(1)}
                      </div>
                    </div>
                    <div className="flex justify-between gap-2 mt-2">
                      <div className="flex flex-row gap-2">
                        <p className="text-gray-400 text-xs">Submitted on</p>
                        <p className="text-gray-400 text-xs">
                          {documentUploadedAt
                            ? documentUploadedAt
                            : "Not submitted"}
                        </p>
                      </div>
                      <div>
                        <div className="flex gap-2">
                          {documentFilePath && (
                            <>
                              <button
                                className="text-[#FFCA20] text-sm"
                                onClick={() => {
                                  openDocumentModal(doc);
                                }}
                              >
                                View
                              </button>
                              <button
                                className="text-[#FFCA20] text-sm"
                                onClick={async () => {
                                  try {
                                    const response = await fetch(documentFilePath);
                                    const blob = await response.blob();
                                    const url = window.URL.createObjectURL(blob);
                                    const link = document.createElement("a");
                                    link.href = url;
                                    link.download = documentFileName || `document_${documentType}`;
                                    document.body.appendChild(link);
                                    link.click();
                                    document.body.removeChild(link);
                                    window.URL.revokeObjectURL(url);
                                  } catch (error) {
                                    console.error("Download failed:", error);
                                    // Fallback: try direct download
                                    const link = document.createElement("a");
                                    link.href = documentFilePath;
                                    link.download = documentFileName || `document_${documentType}`;
                                    link.click();
                                  }
                                }}
                              >
                                Download
                              </button>
                            </>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                );
              })
            ) : (
              <div className="col-span-2 text-center text-gray-400 py-8">
                No documents uploaded yet
              </div>
            )}
          </div>
        </div>
      </div>
      <div className="bg-[#131313] border border-[#333333] p-6 rounded-lg overflow-x-auto scrollbar-hide">
        <h3 className="text-lg font-bold mb-4 flex items-center">
          <ScrollText className="text-[#FFCA20] mr-2" />
          Pay-out History
        </h3>
        <div className="overflow-x-auto scrollbar-hide">
        <table className="w-full text-sm text-left overflow-x-auto border-t rounded-lg border-[#333333]">
          <thead className="text-gray-400 border-x border-[#333333]">
            <tr className="border-x border-[#333333]">
              <th className="py-2 border-x border-[#333333]">INVOICE</th>
              <th className="py-2 border-x border-[#333333]">PAYMENT MODE</th>
              <th className="py-2 border-x border-[#333333]">AMOUNT</th>
              <th className="py-2 border-x border-[#333333]">DATE</th>
              <th className="py-2 border-x border-[#333333]">ACTIONS</th>
            </tr>
          </thead>
          <tbody className="text-white">
            {payouts.map((payout, index) => (
              <tr key={index} className="border-x border-[#333333]">
                <td className="py-3 border-x border-[#333333]">{payout.invoice}</td>
                <td className="py-3 border-x border-[#333333]">{payout.mode}</td>
                <td className="py-3 border-x border-[#333333]">{payout.amount}</td>
                <td className="py-3 border-x border-[#333333]">{payout.date}</td>
                <td className="py-3 border-x border-[#333333]">
                  <div className="flex space-x-4 text-sm">
                    <button className="text-white hover:underline">View</button>
                    <button className="text-[#FFCA20] flex items-center hover:underline">
                      <FileDown className="w-4 h-4 mr-1" /> Download
                    </button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        </div>
      </div>
    </>
  );
}
